// React
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { translateWithI18Next } from '@kfc-global/kfc-i18n';

/**
 * ToggleTabsComponent - A component that creates a row of tabs you can toggle between
 * @param props - tabList {Array} - [ { id: '', title: '' }, ]
 * @returns {JSX.Element}
 * @constructor
 */
const ToggleTabsComponent = props => {
  const { defaultSelectedTabIndex, onTabSelection, tabsList } = props;

  const [selectedTabIndex, setSelectedTabIndex] = useState(defaultSelectedTabIndex);

  /**
   * updatedToggleTabData - event triggered on press of a tab to swap which is selected
   * @param index
   */
  const updatedToggleTabData = index => {
    if (index !== selectedTabIndex) {
      setSelectedTabIndex(index);
      onTabSelection(index);
    }
  };

  return (
    <div className={'toggle-tabs'}>
      {tabsList.map((tabDetails, index) => (
        <div key={tabDetails.id} className={'toggle-tabs-container'}>
          <button
            className={`toggle-tabs-button ${index === selectedTabIndex ? 'selected' : ''}`}
            aria-pressed={index === selectedTabIndex}
            onClick={() => updatedToggleTabData(index)}
          >
            <span className={'toggle-tabs-button-text'}>{translateWithI18Next(tabDetails.title)}</span>
          </button>
        </div>
      ))}
    </div>
  );
};

ToggleTabsComponent.defaultProps = {
  defaultSelectedTabIndex: 0,
  onTabSelection: () => null,
  tabsList: [],
};

ToggleTabsComponent.propTypes = {
  defaultSelectedTabIndex: PropTypes.number,
  onTabSelection: PropTypes.func,
  tabsList: PropTypes.array,
};

export default ToggleTabsComponent;
